export enum ADPYNNAEnum {
    Y = 1,
    N = 2,
    NA = 3
}
